module.exports = __webpack_public_path__ + "img/3x.7893049.jpg";